// Mirrors src/components/common/SummaryCard.tsx — surface bg, uppercase label,
// 22px value, optional 3px left accent.

import React from 'react'
import clsx from 'clsx'

interface SummaryCardProps {
  label: string
  value: number | string
  valueClass?: string   // e.g. 'text-statusGreen', 'text-statusRed'
  accentColor?: string  // hex / var() for left border
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  label,
  value,
  valueClass,
  accentColor,
}) => (
  <div
    className={clsx(
      'flex-1 rounded-md border border-surfaceBorder bg-surface px-lg py-lg',
      'min-h-[68px] flex flex-col justify-center',
    )}
    style={accentColor ? {borderLeftColor: accentColor, borderLeftWidth: 3} : undefined}
  >
    <div className="mb-0.5 text-xs font-medium uppercase text-textSecondary">
      {label}
    </div>
    <div className={clsx('text-xxl font-bold tabular-nums', valueClass ?? 'text-textPrimary')}>
      {value}
    </div>
  </div>
)
